// extracted by mini-css-extract-plugin
export default {"switch":"switch-Nz5x","auto":"auto-ShTe","day":"day-UEuD","sunset":"sunset-KWRP","dark":"dark-jQFg","active":"active-vzFr"};